import { render, staticRenderFns } from "./woman.vue?vue&type=template&id=09848558&scoped=true"
import script from "./woman.vue?vue&type=script&lang=js"
export * from "./woman.vue?vue&type=script&lang=js"
import style0 from "./woman.vue?vue&type=style&index=0&id=09848558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09848558",
  null
  
)

export default component.exports